import React, { useContext, useState, useEffect } from 'react';
import { LocalizationContext } from '../../../contexts';
import './index.scss';

const ThumbnailUploader = ({ thumbnailId, onChange, style = {} }) => {
    const [localization] = useContext(LocalizationContext);
    const [links, setLinks] = useState({
        size1: false,
        size2: false
    });
    const [previewLink1, setPreviewLink1] = useState(false);
    const [previewLink2, setPreviewLink2] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [error, setError] = useState(false);
    const [timer, setTimer] = useState(false);

    useEffect(() => {

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);

    useEffect(() => {
        setLinks(thumbnailId ? {
            size1: window.cet.microservices.contentapi.thumbnails.getImageUrl({ id: thumbnailId, width: 666, height: 239 }),
            size2: window.cet.microservices.contentapi.thumbnails.getImageUrl({ id: thumbnailId, width: 220, height: 186 })
        } : {
                size1: false,
                size2: false
            });
        setPreviewLink1(thumbnailId ? window.cet.microservices.contentapi.thumbnails.getImageUrl({ id: thumbnailId, width: 666, height: 239 }) : false);
        setPreviewLink2(thumbnailId ? window.cet.microservices.contentapi.thumbnails.getImageUrl({ id: thumbnailId, width: 220, height: 186 }) : false);
        setError(false);
    }, [thumbnailId]);

    const showError = (errorMas) => {
        setError(errorMas);
        setTimer(setTimeout(() => {
            setTimer(false);
            setError(false);
        }, 2000));
    };

    const isDraggingOn = () => {
        setIsDragging(true);
    };
    const isDraggingOff = () => {
        setIsDragging(false);
    };

    const uploadFile = (files) => {
        if (!files || files.length !== 1) {
            showError(localization.labels.thumbnailUploader.select_one_image);
            return;
        }

        var file = files[0];
        var fileSize = file.size ? file.size : 0;
        var fileType = file.type ? file.type.toLowerCase() : "";
        if (fileSize > 5 * 1024 * 1024) { // 5MB
            showError(localization.labels.thumbnailUploader.max_file_size);
            return;
        }
        if (["image/jpeg", "image/jpg", "image/png"].indexOf(fileType) < 0) {
            showError(localization.labels.thumbnailUploader.unsupported_file_format);
            return;
        }

        var reader = new FileReader();
        reader.onloadend = () => {
            setPreviewLink1(reader.result);
            setPreviewLink2(reader.result);
        };
        reader.readAsDataURL(file);

        onChange(file);
    };

    return (
        <div className="app-uploader app-uploader--thumbnail" style={style}>
            <div className="app-uploader--thumbnail-upload_block">
                <div className="app-uploader--thumbnail-dropzone"
                    data-isDragging={isDragging ? 1 : 0}
                    onDragEnter={isDraggingOn}
                    onDragOver={isDraggingOn}
                    onDragLeave={isDraggingOff} onDrop={(e) => {
                        isDraggingOff();
                        uploadFile(e.dataTransfer.files);
                    }}
                    onClick={() => {
                        var inputFile = document.createElement("input");
                        inputFile.type = "file";
                        inputFile.accept = ".jpeg, .jpg, .png";
                        inputFile.onchange = function (e) {
                            uploadFile(e.target.files);
                        };
                        inputFile.click();
                    }}
                >
                    {(previewLink1 || previewLink2) && <div className="app-uploader--thumbnail-preview">
                        {previewLink1 && <div className="app-uploader--thumbnail-preview--size1" style={{ "background-image": "url('" + previewLink1 + "')" }}></div>}
                        {previewLink2 && <div className="app-uploader--thumbnail-preview--size2" style={{ "background-image": "url('" + previewLink2 + "')" }}></div>}
                    </div>}
                    <div className="app-uploader--thumbnail-drag_tooltip">
                        {!error && <span><div className="k-icon k-i-upload"></div>{localization.labels.thumbnailUploader.choose_image}</span>}
                    </div>
                    <div className="app-uploader--thumbnail-error">{error && <span><div className="k-icon k-i-exception"></div>{error}</span>}</div>
                </div>
                <div className="app-uploader--thumbnail-links">
                    {links.size1 && <div className="app-uploader--thumbnail-link"><h3 style={{color: "#009e00"}}>{localization.labels.thumbnailUploader.image_title_size_1}:</h3><a href={links.size1} target="_blank">{links.size1}</a></div>}
                    {links.size2 && <div className="app-uploader--thumbnail-link"><h3 style={{color: "#ff0000"}}>{localization.labels.thumbnailUploader.image_title_size_2}:</h3><a href={links.size2} target="_blank">{links.size2}</a></div>}
                </div>
            </div>
            <div className="k-form-hint k-text-start">{localization.labels.thumbnailUploader.hint}  {localization.labels.thumbnailUploader.update_after_save}</div>
        </div>
    );
};

export default ThumbnailUploader;